export default __webpack_public_path__ + "media/src/images/assign_route/split_circle-d164da79b88525ad6ba30a17124bc461.svg";